import { successCotizacion, correoEnviado, continuar, cierraModal, siguiente } from '../reducer/todo-reducer';
import $ from 'jquery';
import { properties } from '../properties/properties';
import axios from 'axios';

export default {

    getCotizacion(values) {
        return new Promise((resolve, reject) => {
            var plazo = values.edadApoyo - values.paso1.edadHijo;
            var modulo = values.paso1.montoMensual / 1000;
            var sumaAsegurada = 60000 * modulo;
            var ahorroGarantizado = (values.paso1.montoMensual * 60000) / 1000;
            var apoyo = values.edadApoyo === 18 ? "Universidad" : "Maestría";

            var cotizacion =
            {
                "cotizacion": [{
                    "vidasConjuntas": false,
                    "producto": "Profesional",
                    "plazo": plazo,
                    "moneda": "MXP",
                    "sumaAsegurada": sumaAsegurada,
                    "modulo": modulo,
                    "moduloVeces": 1,
                    "necesidad": "Educacion",
                    "asegurado1": [{
                        "nombrea": values.paso1.nombre,
                        "apellidos": values.paso1.apellido,
                        "correo": values.paso1.correo,
                        "tip_telefono": values.paso1.tTelefono,
                        "telefono": values.paso1.telefono,
                        "edad": values.paso1.edad,
                        "genero": values.paso1.genero,
                        "habito": values.paso1.habito,
                        "riesgo": "Estandar"
                    }],
                    "hijo": [{
                        "edad": values.paso1.edadHijo,
                        "monto_mensual": values.paso1.montoMensual,
                        "apoyo": apoyo
                    }]

                }]

            };

            axios({
                method: 'post',
                url: properties().COTIZA_EDUCACION,
                data: cotizacion,
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': properties().API_KEY
                }
            }).then((response) => {
                if (response.data) {
                    var jsonP = response.data;
                    console.log("ResponseDiego: " + JSON.stringify(jsonP));

                    if (jsonP.cotizacion !== undefined && jsonP.cotizacion !== null) {

                        var rst = {
                            cotizacion: jsonP.cotizacion,
                            ahorroGarantizado: ahorroGarantizado,
                            tipo: values.edadApoyo,
                            nombre: values.paso1.nombre
                        }
                        resolve(rst);

                    } else {
                        resolve({ error: true });
                    }
                } else {
                    resolve({ error: true })
                }
            }).catch((error) => {
                resolve({error: true});
            });	
        }).then(successCotizacion);
    },
    envioCorreoCotizacion(values) {
        return new Promise((resolve, reject) => {

            var apoyo = values.cotizacion.tipo === 18 ? "Universidad" : "Maestría";
            const espacio = "<p>&nbsp;</p>";
            var message = "<table>" +
                "<tbody>" +
                "<tr>" +
                "<td><img class=\"CToWUd\" src=\"https://ci6.googleusercontent.com/proxy/8TvAszlGk1Y-vCzwsI18bW_yyS2eUKvULdmdNmNewMMU1S4O_qlp5RlTODqnOWTZPIJnilXHn2kWFLTwA" +
                "PedsI5OTFjxR1htT4EXgHrnV8LiQg734qknla7ULdNZpGw=s0-d-e1-ft#https://storage.googleapis.com/gnp-vdi-pro.appspot.com/mail/img/logo-gnp.png\" alt=\"\" \/></td>" +
                "</tr>" +
                "<tr>" +
                "<td colspan=\"2\">&nbsp;</td>" +
                "</tr>" +
                "<tr>" +
                "<td colspan=\"2\">" +
                "<h1><span style=\"display: block; color: #004479; font-size: 25px; text-align: center; margin-top: 40px;\">¡Hola " + values.cotizacion.nombre + "!</span></h1>" +
                "<p><span style=\"display: block; color: #004479; font-size: 25px; text-align: center; margin-top: 40px;\">" +
                "Te enviamos la cotizaci&oacute;n para apoyar a tu hijo en la " + apoyo + "</span></p>" +
                "<h1><span style=\"color: #000080; \">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; " +
                "&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; " +
                "&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; " +
                "&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;&nbsp;</span></h1>" +
                espacio +
                "<table style=\"height: 86px; margin-left: auto; margin-right: auto; width: 347px;\">" +
                "<tbody>" +
                "<tr style=\"height: 35px;\">" +
                "<td style=\"background-color:#EEEEEE; width: 170px; height: 35px;\">" +
                "<p><span style=\"text-align: right; font-weight: 400;\">Ahorrando mensualmente</span></p>" +
                "</td>" +
                "<td style=\"width: 97px; height: 35px;\">" +
                "<p><span style=\"text-align: right; font-weight: 400;\">$ " + 
                Math.floor(values.cotizacion.cotizacion).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " *&nbsp;</span></p>" +
                "</td>" +
                "</tr>" +
                "<tr style=\"height: 35.9375px;\">" +
                "<td style=\"background-color:#EEEEEE; width: 170px; height: 35.9375px;\">" +
                "<p><span style=\"text-align: right; font-weight: 400;\">Lograr&aacute;s un ahorro garantizado de</span></p>" +
                "</td>" +
                "<td style=\"width: 97px; height: 35.9375px;\">" +
                "<p><span style=\"text-align: right; font-weight: 400;\">$ " + 
                Math.floor(values.cotizacion.ahorroGarantizado).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " *</span></p>" +
                "</td >" +
                "</tr >" +
                "</tbody >" +
                "</table >" +
                espacio +
                espacio +
                "<p><span style=\"font-weight: 400;\">Si desafortunadamente llegaras a faltar antes de ese plazo, se les entregar&aacute; a tus " +
                "beneficiarios $" + Math.floor(values.cotizacion.ahorroGarantizado).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + 
                ", </span><strong>adicionales al Ahorro Garantizado que se le dar&aacute; a tu hijo a los " + values.cotizacion.tipo + 
                " a&ntilde;os para su educaci&oacute;n.</strong></p>" +
                espacio +
                "<p><span style=\"font-weight: 400;\">*La prima y suma asegurada se actualizan con la inflaci&oacute;n.</span></p>" +
                espacio +
                espacio +
                "<div>" +
                "<table style=\"margin-left: auto; margin-right: auto;\">" +
                "<tbody>" +
                "<tr>" +
                "<td>" +
                "<div style = \"text-align: center;\" >" +
                "<table>" +
                "<tbody>" +
                "<tr style=\"height: 34px;\">" +
                "<td style=\"height: 34px;\">" +
                "<p align=\"center\">Puedes responder este correo para recibir atenci&oacute;n personalizada o si prefieres ll&aacute;manos:</p>" +
                "</td>" +
                "</tr>" +
                "<tr style=\"height: 62px;\">" +
                "<td style=\"height: 62px;\">" +
                "<div> <img class=\"CToWUd\" src=\"https://ci6.googleusercontent.com/proxy/wJPzvcEzNtmV0RWe1ZimM0vLwOK3fdVjBXqWorEpSRCkUJnYPFvX8WtCg7y93jK-Z1fdBwp" +
                "Tc4eRyMQj2E6ypEZ1ZLa45wpvM2nQmdw7jzv0AFLhWEjTcCgX8O8=s0-d-e1-ft#https://storage.googleapis.com/gnp-vdi-pro.appspot.com/mail/img/linea.jpg\" alt=\"\" /></div >" +
                "</td >" +
                "</tr >" +
                "<tr style=\"height: 12.9375px;\">" +
                "<td style=\"height: 12.9375px;\">&nbsp;</td>" +
                "</tr>" +
                "<tr style=\"height: 12px;\">" +
                "<td style=\"height: 12px;text-align: center; display: block;margin-top: 35px;\"><small>Cotizaci&oacute;n sujeta a cambios sin previo aviso</small></td>" +
                "</tr>" +
                "</tbody >" +
                "</table >" +
                "</div >" +
                "</td >" +
                "</tr >" +
                "</tbody >" +
                "</table >" +
                "</div >" +
                "<hr />" +
                "<p><strong>PROTECCI&Oacute;N DE DATOS PERSONALES.-</strong>&nbsp;Grupo Nacional Provincial, S.A.B. (GNP) " +
                "con domicilio en Avenida Cerro de las Torres n&uacute;mero 395, Colonia Campestre Churubusco, C&oacute;digo Postal 04200, " +
                "Delegaci&oacute;n Coyoac&aacute;n, Ciudad de M&eacute;xico, le informa que los datos personales que reciba de GNP en calidad " +
                "de Encargado, deben ser tratados conforme al Aviso de Privacidad Integral de GNP puesto a disposici&oacute;n del titular " +
                "previo a la captaci&oacute;n de los datos; as&iacute; mismo la recepci&oacute;n de datos personales en GNP se efect&uacute;a " +
                "en el entendido de que usted obtuvo previamente el consentimiento de los titulares de los mismos.</p>" +
                "<p>El tratamiento de los datos personales en GNP se realiza de conformidad con el Aviso de Privacidad Integral que se " +
                "encuentra disponible en la p&aacute;gina de internet&nbsp;<a>www.gnp.com.mx</a>&nbsp;en la secci&oacute;n aviso de privacidad.</p>" +
                "<p>La informaci&oacute;n contenida en este mensaje es confidencial y restringida, y est&aacute; destinada &uacute;nicamente " +
                "para el uso de la persona a quien se dirige. Por lo tanto, queda prohibido su uso a persona ajena al destinatario indicado y/o " +
                "para fines diferentes a los que se expresan en este mensaje. Por lo que, cualquier uso distinto al expresamente autorizado, o " +
                "por persona distinta al destinatario, est&aacute; estrictamente prohibido; de tal forma que GNP S.A.B., no se hace responsable " +
                "de dichos usos y se reserva cualquier tipo de acci&oacute;n legal que pudiera derivar contra quien, o quienes, resulten " +
                "responsables de su divulgaci&oacute;n, reproducci&oacute;n o uso, sin previa autorizaci&oacute;n por escrito por parte de GNP S.A.B.</p>" +
                "<p>Este mensaje no tiene como prop&oacute;sito, entre el destinatario y el remitente, " +
                "el uso de pr&aacute;cticas anticompetitivas referidas o se&ntilde;aladas en la Ley Federal de Competencia Econ&oacute;mica " +
                "relacionadas con la fijaci&oacute;n de precios o condiciones que impliquen barreras de entrada; o bien, el desplazamiento " +
                "de competidores al mercado asegurador, ni establecer un poder sustancial conjunto entre el destinatario y el remitente.</p>" +
                "</td >" +
                "</tr >" +
                "</tbody >" +
                "</table > ";

            var bodyRequest = {
                from: properties().CORREOS_FROM,
                to: values.correo,
                subject: "[COTIZACIÓN] Asegura la colegiatura de tus hijos con Profesional GNP", //"Cotización de Seguro Educativo",
                typeBody: "html",
                message: message

            };

            console.log("RequestCorreo------------" + bodyRequest);

            $.ajax({
                url: properties().CORREO_ENDPOINT,
                type: "POST",
                data: bodyRequest,
                dataType: 'json',
                success: function (data, status, req) {

                    console.log(req.responseText);

                },
                error: function (data, status, req) {

                    console.log("No se logro enviar el correo");
                }
            });

            resolve(true);

        }).then(correoEnviado)
    },
    regresar() {
        return new Promise((resolve, reject) => {
            resolve(false);
        }).then(continuar);
    },
    regresarTipo() {
        return new Promise((resolve, reject) => {
            console.log("RegresarTipo");
            resolve(false);
        }).then(continuar);
    },
    siguiente() {
        return new Promise((resolve, reject) => {
            resolve(true);
        }).then(continuar);
    },
    cerrarModal() {
        return new Promise((resolve, reject) => {
            resolve(false);
        }).then(cierraModal);
    },
    abrirModal() {
        return new Promise((resolve, reject) => {
            resolve(true);
        }).then(cierraModal);
    }
}



// WEBPACK FOOTER //
// ./src/apis/todo-api.js